module.exports = __webpack_public_path__ + "fonts/segoeuil.d44929d6.ttf";